import {RDate} from '@app/core/models/rDate.model';
import {Shift} from '@app/core/models/shift.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class SickMessage extends BaseModel {
	public id: number;
	public message: string;
	public shift: Shift;
	public success_sick_message_responses_count: number;
	public created_at: RDate;
	public updated_at: RDate;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}
		if (input.shift) {
			this.shift = new Shift(this.tenantTZ, this.interService).deserialize(input.shift);
		}
		
		return this;
	}
}
